<template>
  <div class="flex items-center text-gray-400">
    <button type="button"
            class="mr-2 text-left font-semibold text-gray-900"
            @click="sort">
      <slot></slot>
    </button>
    <template v-if="isAsc">
      <BaseIcon name="arrow-up" />
    </template>
    <template v-if="isDesc">
      <BaseIcon name="arrow-down" />
    </template>
  </div>
</template>

<script>
export default {
  props: {
    column: {
      type: String,
      required: true
    }
  },

  computed: {
    isAsc() {
      return this.$route.query.sort == this.column;
    },

    isDesc() {
      return this.$route.query.sort == this.column + ".desc";
    }
  },

  methods: {
    sort() {
      this.$emit("sort", this.isAsc ? this.column + ".desc" : this.column);
    }
  }
};
</script>
